let _rateCache = null
let _rateCacheTime = 0
const CACHE_TTL = 5 * 60 * 1000

export const CURRENCY_SYMBOLS = {
    USD: '$', EUR: '€', TRY: '₺', GBP: '£',
    RUB: '₽', JPY: '¥', CNY: '¥', AZN: '₼',
}

export async function fetchRates(axios, endpoint) {
    if (_rateCache && (Date.now() - _rateCacheTime) < CACHE_TTL) {
        return _rateCache
    }
    const res = await axios.get(endpoint)
    const data = res.data?.data || res.data
    const rateMap = {}
    if (Array.isArray(data)) {
        data.forEach(item => { rateMap[item.code || item.currency_code] = parseFloat(item.rate) })
    } else if (typeof data === 'object') {
        Object.assign(rateMap, data)
    }
    if (!rateMap['TRY']) rateMap['TRY'] = 1
    _rateCache = rateMap
    _rateCacheTime = Date.now()
    return rateMap
}

export function formatCurrency(val, decimals = 2) {
    if (Number.isInteger(val)) return val.toLocaleString('tr-TR')
    return val.toLocaleString('tr-TR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}
